export const ProjectInventoryItemAdjustmentTypeEnumValue = {
  AdditionalItem: 10,
  DealerInventory: 20,
};

export const ProjectInventoryItemAdjustmentTypeEnum = [
  {
    value: ProjectInventoryItemAdjustmentTypeEnumValue.AdditionalItem,
    name: 'AdditionalItem',
    labelFrench: 'Article additionnel',
    labelEnglish: 'Additional item',
  },
  {
    value: ProjectInventoryItemAdjustmentTypeEnumValue.DealerInventory,
    name: 'DealerInventory',
    labelFrench: 'Article existant à retiré',
    labelEnglish: 'Existing Racking to subtract',
  },
];

export default ProjectInventoryItemAdjustmentTypeEnum;
